(function ($) {
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop + $(this).outerHeight() && elementTop < viewportBottom;
    };

    let index;
    let indexTwo = null;

    $('.product-system-selection .first-question a').click(function(e){
        $('.product-system-selection .first-question a').removeClass('active');
        $(this).addClass('active');
        index = $('.product-system-selection .first-question a').index($(this))
        $('.product-system-selection .second-question').slideDown();
        if(!$('.product-system-selection .second-question').isInViewport()) {
            $('html').animate({
                scrollTop: $('.product-system-selection .second-question').offset().top - 120
            }, 450);
        }
        if ($(this).closest('.elementor-column').hasClass('passive')) {
          $('.second-question').addClass('passive');
          $('.elementor-button-link.offer').addClass('passive');
        } else {
          $('.second-question').removeClass('passive');
          $('.elementor-button-link.offer').removeClass('passive');
        }
        productSystemRedirectLink();
        e.preventDefault();
    });

    $('.product-system-selection .second-question a').click(function(e){
        $('.product-system-selection .second-question a').removeClass('active');
        $(this).addClass('active');
        indexTwo = $('.product-system-selection .second-question a').index($(this))

        productSystemRedirectLink();
        e.preventDefault();
    });

    let resultPage;

    function productSystemRedirectLink() {
        console.log(indexTwo)
        if (indexTwo == null) {
            return false;
        }
        if (index == 0 && indexTwo == 0) {
          resultPage = $('.product-system-selection').data('izostandardhouse-link');
        } else if (index == 0 && indexTwo == 1) {
            resultPage = $('.product-system-selection').data('izostandard-link');
        } else if (index == 1 && indexTwo == 0) {
          resultPage = $('.product-system-selection').data('izoenergycomplex-link');
        } else if (index == 1 && indexTwo == 1) {
          resultPage = $('.product-system-selection').data('izoenergy-link');
        } else if (index == 2 && indexTwo == 0) {
          resultPage = $('.product-system-selection').data('izopassivecomplex-link');
        } else if (index == 2 && indexTwo == 1) {
          resultPage = $('.product-system-selection').data('izopassive-link');
        }
        $('.product-system-selection .offer').attr('href', resultPage);
        $('.product-system-selection .results').slideDown();
    }
  
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/product-selection.js